@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .verticalLine {
    stroke: var(--border-default);
    stroke-width: 2px;
  }

  .verticalLineMuted {
    stroke: var(--border-soft);
    stroke-width: 1px;
  }

  .verticalLineSelected {
    stroke: var(--border-primary);
  }

  .label {
    @include typography-v2-body-xs;
    fill: var(--text-soft);
    font-family: var(--font-nort);
    text-transform: uppercase;
  }
}
